import { render, staticRenderFns } from "./CoozzyPageTitle.vue?vue&type=template&id=96823572&scoped=true"
import script from "./CoozzyPageTitle.vue?vue&type=script&lang=js"
export * from "./CoozzyPageTitle.vue?vue&type=script&lang=js"
import style0 from "./CoozzyPageTitle.vue?vue&type=style&index=0&id=96823572&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96823572",
  null
  
)

export default component.exports